import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

export const initCounters = (): void => {
  // Clear any existing ScrollTriggers to prevent duplicate instances during Vite HMR
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.trigger && (trigger.trigger as HTMLElement).id === 'estadisticas') {
      trigger.kill();
    }
  });

  const statsSection = document.getElementById('estadisticas');
  if (!statsSection) return;

  const statNumbers = statsSection.querySelectorAll('.stat-number');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  statNumbers.forEach((el) => {
    const htmlEl = el as HTMLElement;
    const targetVal = parseFloat(htmlEl.getAttribute('data-target') || '0');
    const prefix = htmlEl.getAttribute('data-prefix') || '';
    const suffix = htmlEl.getAttribute('data-suffix') || '';

    if (prefersReducedMotion) {
      const formattedVal = Math.floor(targetVal).toLocaleString('en-US');
      htmlEl.innerText = `${prefix}${formattedVal}${suffix}`;
    } else {
      // Temp object for GSAP to animate
      const tempObj = { value: 0 };

      gsap.to(tempObj, {
        value: targetVal,
        duration: 1.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: statsSection,
          start: 'top 85%', // Trigger counter animation when the stats section enters the viewport
          once: true,
        },
        onUpdate: () => {
          // Format numbers with commas (e.g. 12,000)
          const formattedVal = Math.floor(tempObj.value).toLocaleString('en-US');
          htmlEl.innerText = `${prefix}${formattedVal}${suffix}`;
        }
      });
    }
  });
};
